import { makeSx } from '@saas/lib/shared-utils'
import { defaultPalette } from '../../theme/idsTheme'

export const sxs = makeSx({
    page: {
        position: 'relative',
        boxSizing: 'border-box',
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: defaultPalette.secondary.ultraLight,
        padding: '1.5rem',
    },
    card: {
        width: '100%',
        maxWidth: '25rem',
        backgroundColor: defaultPalette.white.main,
        borderRadius: '1rem',
        boxShadow: '0px 12px 32px 0px rgba(46, 13, 166, 0.08)',
        padding: { xs: '2rem 1.75rem', sm: '3.5rem 3rem' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '2rem',
    },
    support: {
        position: 'absolute',
        right: { xs: '1.5rem', sm: '3rem' },
        bottom: { xs: '1.5rem', sm: '2.5rem' },
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    },
    supportIcon: {
        width: '2.25rem',
        height: '2.25rem',
        color: defaultPalette.typography.main,
    },
    supportText: {
        fontSize: '0.95rem',
        fontWeight: 700,
        lineHeight: 1.3,
        textAlign: 'left',
        color: defaultPalette.typography.main,
    },
    supportLink: {
        color: defaultPalette.primary.main,
        textDecorationColor: defaultPalette.primary.main,
    },
})
